import React from 'react'
import Header from '../Header/Header'
import ClientesData from '../../Components/Admin/ClientesData/ClientesData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
export default function Productos() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <ClientesData />
                </div>
            </section>
        </div>
    )
}
